<template>
  <div class="multi-file-upload">
    <i v-if="CFileList.length" class="el-icon-paperclip"></i>
    <customize-button @click="dialogVisible = true">
      Upload Documents
    </customize-button>
    <el-dialog
      title="Upload"
      width="700px"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="upload-content">
        <el-upload
          action=""
          multiple
          :auto-upload="false"
          :limit="limit"
          :on-exceed="handleExceed"
          :file-list="CFileList"
          :show-file-list="false"
          :on-change="handleChange"
        >
          <customize-button>Click to upload</customize-button>
        </el-upload>
        <ul class="file-list">
          <li
            class="list-item"
            v-for="(item, index) in CFileList"
            :key="index"
            @click="handleDownload(item)"
          >
            {{ item.name }}
            <el-popconfirm
              title="Confirm to delete？"
              confirm-button-text="confirm"
              cancel-button-text="cancel"
              @confirm="handleRemoveItem(item, index)"
            >
              <a href="javascript: void (0)" @click.stop slot="reference">
                Delete
              </a>
            </el-popconfirm>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <customize-button type="primary" @click="dialogVisible = false">
          Confirm
        </customize-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { commonDownload, commonRemoveFile } from '@/api'

const UPLOAD_READY = 'ready'

export default {
  name: 'multi-file-upload',
  props: {
    limit: {
      type: Number,
      default: 15,
    },
    fileList: {
      type: Array,
      default: () => [],
    },
    downloadUrl: {
      type: String,
      default: '',
    },
    removeUrl: {
      type: String,
      default: '',
    },
  },
  watch: {
    fileList: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.CFileList = [...newValue]
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      CFileList: [],
      acceptFileTypes: [
        'png',
        'gif',
        'pjp',
        'jpg',
        'jpeg',
        'bmp',
        'csv',
        'xlsm',
        'xltm',
        'ico',
        'xls',
        'xlsx',
        'doc',
        'docx',
        'pdf',
        'ppt',
        'pptx',
        'txt',
        'rar',
        'zip',
        'html',
        'msg',
      ],
    }
  },
  methods: {
    handleDownload(raw) {
      const { id } = raw
      if (!this.downloadUrl && id) {
        commonDownload(id)
      }
    },
    handleChange(file) {
      // 判断文件后缀格式
      const _index = file.name.lastIndexOf('.')
      const _type = file.name.substr(_index + 1)
      if (this.acceptFileTypes.indexOf(_type) === -1) {
        this.$message.error(`.${_type} is invalid`)
        this.CFileList = [...this.CFileList]
        return
      }
      // 单个文件不能超过50M
      const fileSize = Number(file.size / 1024 / 1024)
      if (file.status === UPLOAD_READY && fileSize < 50) {
        this.CFileList.push(file)
      } else {
        this.$message.error('File must not exceed 50M')
        this.CFileList = [...this.CFileList] // 重置列表，如果不重置会出现第五个超出体积再传符合的传不上去
      }
    },
    handleExceed() {
      this.$message.warning(
        'Maximum fifteen files can be uploaded. Each file cannot exceed 50M.',
      )
    },
    async handleRemoveItem({ id }, index) {
      if (id) {
        await commonRemoveFile(id)
        this.$message.success('success')
      }
      this.CFileList.splice(index, 1)
    },
    getCFileList() {
      return this.CFileList
    },
    clearFileList() {
      this.CFileList = []
    },
  },
}
</script>

<style scoped lang="scss">
.file-list {
  margin-top: 20px;
  .list-item {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    line-height: 30px;
    padding: 0 10px;
    border-radius: 8px;

    &:hover {
      background-color: #e2e2e5;
    }
  }
}
</style>
